// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "footer{padding:15px;font-size:1.5rem}footer .fa-heart{color:red}", ""]);
// Exports
module.exports = exports;
